import { render } from "./user-menu-edit.vue?vue&type=template&id=f9ab5726&scoped=true"
import script from "./user-menu-edit.vue?vue&type=script&lang=js"
export * from "./user-menu-edit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ab5726"]])

export default __exports__